import React, { FC } from "react";
import FormStep from "../../types/FormStep";
import "./Stepper.css";

interface StepperProps {
  activeStep: number;
  steps: FormStep[];
}

const Stepper: FC<StepperProps> = ({ activeStep, steps }) => {
  let progressClass = "";
  for (let j = 0; j < activeStep + 1; j += 1) {
    progressClass = `${progressClass}bar${j + 1} `;
  }
  return (
    <div className="stepper-container">
      <div className="stepper-container__stepper">
        <div className={progressClass} />
        {steps.map((step, index) => {
          return (
            <div
              className={`step step${index + 1} ${index === activeStep ? "active" : ""} ${index < activeStep ? "complete" : ""}`}
            >
              {index === steps.length - 1 ? "✓" : index + 1}
            </div>
          );
        })}
        <div className="labels__container">
          {steps.map((step, index) => {
            return (
              <div
                key={step.stepName}
                className={`label label${index + 1} ${index === activeStep ? "active" : ""} ${
                  index < activeStep ? "complete" : ""
                }`}
              >
                <div className="desktop-view">{step.stepName}</div>
                <div className="mobile-view">{step.shortName}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Stepper;
